<template>
  <el-dialog :title="$t('couponManage.deleteCoupon')" :visible.sync="dialogVisible" width="500px"
    @close="handleClose">
    <div>
      <p>{{ $t('couponManage.confirmOperation') }}</p>
      <p>{{ $t('couponManage.confirmDeleteCoupon') }}：{{ deleteCouponInfo.couponName }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="danger" @click="deleteCouponInfoMethod">
        {{ $t('couponManage.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteShopCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'DeleteShopCoupon',
  data() {
    return {
      dialogVisible: false,
      deleteCouponInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteCouponInfo = { ...row }
    },
    handleClose() {
      this.deleteCouponInfo = {}
    },
    async deleteCouponInfoMethod() {
      try {
        await deleteShopCoupon({ couponId: this.deleteCouponInfo.couponId })
        this.$message.success(this.$t('common.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>

